import type { ReactNode } from "react";

interface FieldGroupProps {
  icon: ReactNode;
  title: string;
  children: ReactNode;
}

export function FieldGroup({ icon, title, children }: FieldGroupProps) {
  return (
    <section className="space-y-3 border-t border-border/50 pt-5">
      <h3 className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground">
        {icon}
        <span>{title}</span>
      </h3>
      {children}
    </section>
  );
}
